// extracted by mini-css-extract-plugin
export default {"toggleButton":"toggleButton--AICJi","maxWidth":"maxWidth--GcTup","active":"active--AX1ZJ","toggleButtonWrap":"toggleButtonWrap--fgEob"};